import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { memo, useState } from 'react';
import { ShareDialog } from '../ShareDialog';
export const ShareButton = /*#__PURE__*/ memo(function ShareButton({ chatId, chatTitle }) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraButton, {
                "aria-label": "Share chat",
                "data-testid": Testids.assistant.shareButton,
                onClick: ()=>setIsDialogOpen(true),
                size: "sm",
                variant: "secondary",
                children: "Share"
            }),
            /*#__PURE__*/ _jsx(ShareDialog, {
                chatId: chatId,
                chatTitle: chatTitle,
                isOpen: isDialogOpen,
                onClose: ()=>setIsDialogOpen(false)
            })
        ]
    });
});
